import { createBrowserRouter, RouterProvider } from "react-router-dom";
import Roots from "./Roots";
import { useLayoutEffect, useState } from "react";
import Loader from "./Components/Loader";

import AdminListService from "./services/admin-list.service";
import secureLocalStorage from "react-secure-storage";
import DeniedMsg from "./DeniedMsg";

function App() {
  const [country, setCountry] = useState("");
  const [count, setCount] = useState(0);
  const [countryAllowed, setCountryAllowed] = useState([]);
  const router = createBrowserRouter([{ path: "*", element: <Roots /> }]);

  async function fetchCountry(count) {
    console.log(count);

    setCount(count + 1);
    if (count < 2) {
      try {
        const response = await AdminListService.getAllowedCountry();

        setCountryAllowed(response?.data?.allowed_countries || []);
        if (response?.data?.user_country) {
          secureLocalStorage.setItem("area", response?.data?.user_country);

          setCountry(response?.data?.user_country);
        } else {
          const res = await fetch("https://ipwho.is/");
          const data = await res?.json();

          if (data?.country) {
            secureLocalStorage.setItem("area", data?.country);

            setCountry(data?.country); // e.g. "Pakistan"
            // const org = data.connection?.org || data.connection?.isp || "";
            // if (
            //   /vpn|hosting|cloud|ovh|aws|digitalocean|hetzner|choopa|m247/i.test(
            //     org
            //   )
            // ) {
            //   console.log("⚠️ Possible VPN/Hosting provider:", org);
            // } else {
            //   console.log("✅ Likely residential IP:", org);
            // }
          } else {
            const res2 = await fetch("https://ipapi.co/country_name/");
            const data2 = await res2?.text();
            if (data2) {
              secureLocalStorage.setItem("area", data2);

              setCountry(data2);
            } else {
              setCountry("error");
            }
          }
        }
      } catch (err) {
        fetchCountry(count + 1);
      }
    } else {
      if (!country) {
        setCountry("error");
      }
    }
  }
  useLayoutEffect(() => {
    secureLocalStorage.removeItem("area");
    fetchCountry(count);
  }, []);

  return country === "" ? (
    <Loader />
  ) : countryAllowed?.includes(country) || country === "United States" ? (
    <RouterProvider router={router} />
  ) : (
    <DeniedMsg country={country} />
  );
}

export default App;
